import { render, staticRenderFns } from "./ChangePrograma.vue?vue&type=template&id=e0ad199a"
import script from "./ChangePrograma.vue?vue&type=script&lang=js"
export * from "./ChangePrograma.vue?vue&type=script&lang=js"
import style0 from "./ChangePrograma.vue?vue&type=style&index=0&id=e0ad199a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports